import React from "react";
import { getBullseyeMatchSetupDetail } from "../../lib/leaderboardApi";

export async function loadBullseyeProgramReadiness(matchId) {
  try {
    const result = await getBullseyeMatchSetupDetail(matchId, { auth: true });
    const groups = result?.setupDetail?.gunGroups || [];
    return { state: groups.length ? "ready" : "missing", groups };
  } catch (error) {
    if ([401, 403].includes(error.status)) throw error;
    return { state: [404, 409].includes(error.status) ? "missing" : "error", groups: [] };
  }
}

export default function ScoringProgramNotice({ readiness, onRetry }) {
  if (!readiness || readiness.state === "ready") return null;
  const missing = readiness.state === "missing";
  return <div className="dp-notice" role="status">
    <strong>{missing ? "Scoring program needed" : "Scoring program could not be checked"}</strong>
    <p>{missing
      ? "Publish this match’s course and scoring groups from Range Pocket, then refresh. You can collect registrations and plan relays now; confirming competitors and calculating results need the uploaded program."
      : "Your match and registrations are safe. Retry the program check before confirming competitors or reviewing results."}</p>
    {onRetry && <button type="button" className="dp-button" onClick={onRetry}>Check scoring program again</button>}
  </div>;
}
